import Handlebars from "handlebars/dist/handlebars.js";
import { serviceNetworkError } from "../failhandler";

var createbanner = (function () {
    "use strict";

    if ($('.admincreatebanner').length > 0) {
        $('body').on('click', '#generate-banner', generateBanner);
    }

    function generateBanner(e) {
        e.preventDefault();

        var $this = $(this),
            bannerSize = $("#admin-bannersize-container select"),
            bannerSizeValue = bannerSize.val(),
            bannerSizeText = $("option:selected", bannerSize).text(),
            bannerType = $("#admin-bannertype-container select"),
            bannerTypeValue = bannerType.val(),
            bannerTypeText = $("option:selected", bannerType).text(),
            responseWrap = $this.closest('.module').find('.response-wrapper'),
            errorList = responseWrap.find('.error-list'),
            invalidMessage = responseWrap.attr('data-invalid-message'),
            generateBtn = $('#generate-banner'),
            source = $('#admin-banner-code-template').html(),
            template = Handlebars.compile(source),
            cl = new CanvasLoader('loader'),
            data = {
                "bannerSizeId": bannerSizeValue,
                "bannerType": bannerTypeValue,
                "accountId": ""
            };

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);

        if (bannerSizeValue) {

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.site.methods.getBannerCode,
                data: JSON.stringify(data),
                dataType: "text"
            });

            cl.show();
            generateBtn.addClass('loading');
            responseWrap.hide();

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        }
        else {
            responseWrap.text(invalidMessage).show();
        }

        function doneHandler(response) {

            cl.hide();
            generateBtn.removeClass('loading');

            var html = template({ Code: response });
            openModal();

            Utils.TrackGoogleEvent("Foreningsbanner", "Skapa:Admin", bannerTypeText + ", " + bannerSizeText);

            $('.modal').append(html);
            $('.modal .banner-code textarea').select();
        }

        function failHandler(err) {
            cl.hide();
            generateBtn.removeClass('loading');
            serviceNetworkError(responseWrap);
        }

        function openModal(e) {

            var body = $('body'),
                modal = $('.modal'),
                overlay = $('.overlay'),
                closeBtn = $('<button class="close">&times;</button>'),
                modalData;

            var top, source, template, html;
            modalData = $(this).data();
            modal.append(closeBtn);
            overlay.fadeIn(40);

            top = $(window).height() / 2 - modal.height() / 2 - 100;
            modal.css({ top: top }).fadeIn(40);
        }
    }
})();